/* eslint-disable react/prop-types */
import React, {PureComponent} from 'react';

import {Modal} from 'react-bootstrap';

import LoadingIcon from '@/assets/icons/Loading.gif';
import {newLineHtml} from '@/libs/htmlHelper';

import './loading.less';

class Loading extends PureComponent {
  render() {
    const {isActive, loadingText, loadingClickEvent, loadingButton1, loadingButton2} = this.props;

    const modalStyle = {
      zIndex: 1040,
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      fontSize: 20,
      color: '#FFFFFF',
      overflow: 'hidden',
    };
    const backdropStyle = {
      ...modalStyle,
      zIndex: 1030,
      backgroundColor: '#000',
      opacity: 0.75,
    };

    return (
      <Modal
        className="modal-loading disableTextSelect"
        style={modalStyle}
        backdropStyle={backdropStyle}
        show={isActive}
        dialogClassName="dialog-loading"
        onHide={loadingClickEvent}
      >
        <div
          className="loadingDiv"
          onClick={loadingClickEvent}
        >
          <img
            alt={LoadingIcon}
            className="loadingIcon"
            src={LoadingIcon}
            width={125}
            height={125}
          />
          <span>{newLineHtml(loadingText)}</span>
          {loadingButton1 !== undefined || loadingButton2 !== undefined ? (
            <div className="loadingButtonRow">
              {loadingButton1 !== undefined && (
                <button
                  type="button"
                  onClick={loadingButton1.onClick}
                  className="loadingButton1"
                  id={loadingButton1.id}
                  disabled={loadingButton1.disabled}
                >
                  {loadingButton1.label.toUpperCase()}
                </button>
              )}
              {loadingButton2 !== undefined && (
                <button
                  type="button"
                  onClick={loadingButton2.onClick}
                  className="loadingButton2"
                  id={loadingButton2.id}
                >
                  {loadingButton2.label.toUpperCase()}
                </button>
              )}
            </div>
          ) : null}
        </div>
      </Modal>
    );
  }
}
export default Loading;
